<template>
    <footer class="footer">
       <div style="display: flex;">
        <div class="footNav">
            <div>
                <ul>
                    <li><router-link to="/">网站首页</router-link></li>
                    <li><router-link to="/about">公司介绍</router-link></li>
                    <li><router-link to="/products">产品中心</router-link></li>
                    <li><router-link to="/team">精英团队</router-link></li>
                    <li><router-link to="/news">新闻动态</router-link></li>
                    <li><router-link to="/contactUs">联系方式</router-link></li>
                </ul>
            </div>
            <div class="qrCodeList">
                <div v-for="(codeCell, codeIndex) in companyCode" :key="codeIndex">
                    <img :src="codeCell" />
                </div>
            </div>
        </div>
        <div class="footInfo">
            <div class="logo"><img src="../assets/img1.png" /></div>
            <div>
                <div>
                    <div>电话:</div>
                    <div>{{company.companyOfficeNumber}}</div>
                </div>
                <div>
                    <div>地址:</div>
                    <div>{{company.locationText}}</div>
                </div>
                <div>
                    <div>邮箱:</div>
                    <div>{{company.email}}</div>
                </div>
            </div>
        </div>
       </div>
        <div class="ICPStyle">
            <div @click="goICP" class="mouseCursor">鲁ICP备2025148730号-1</div>
            <div @click="goLGA" class="mouseCursor LgaStyle">
                <img src="../assets/img8.png"/>
                <span>鲁公网安备37069302889147号</span>
            </div>
            <div>版权所有：山东衍明生物科技有限公司</div>
        </div>
    </footer>
</template>
<script>
    import { getCompony } from '@/utils/request.js';
    export default {
        name: 'footerNav',
        data() {
            return {
                company: [],
                companyCode: []
            }
        },
        mounted() {
            this.showCompanyContactus();
        },
        // 方法体
        methods: {
            async showCompanyContactus() {
                try {
                    const response = await getCompony();
                    if (response.code === 200) {
                        this.company = response.data;
                        this.companyCode = this.company.qrCode.split(',');
                    } else {
                        console.error('Failed to fetch departments:', response.msg);
                    }
                } catch (error) {
                    console.error('Error fetching departments:', error);
                }
            },
            goICP(){
                window.open('https://beian.miit.gov.cn/');
            },
            goLGA(){
                window.open('https://beian.mps.gov.cn/#/query/webSearch?code=37069302889147');
            }
        },

    }
</script>
<style scoped>
    .footer {
        background: #F7F7F7;
        /* display: flex; */
        /* padding: 2vw 0vw; */
        padding-top: 2vw;
        /* padding-bottom: 5vw; */
    }

    .footNav {
        flex: 2;
        padding-top: 1vw;
    }

    .footNav>div:nth-child(1) {
        padding-right: 10vw;
        padding-bottom: 4vw;
    }

    .footNav ul {
        list-style-type: none;
        display: flex;
        justify-content: space-around;
        margin-bottom: 0px;
    }

    .footNav ul li {
        padding-bottom: 1.5vw;
        position: relative;
    }

    .footNav ul li a {
        color: #00A1E9;
        text-decoration: none;
        font-size: 1.3vw;
        font-weight: 600;
        display: inline-block;
  position: relative;
       
    }
.footNav ul li a::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 300%;
  height: 300%;
  border-radius: 50%;
  transform: translate(-50%, -50%) scale(0);
  transition: transform 0.5s, width 0.5s, height 0.5s;
}

/* 悬浮时波浪动画 */
.footNav ul li a:hover::before {
  transform: translate(-50%, -50%) scale(1);
  width: 500%;
  height: 500%;
}

/* 鼠标悬浮在 .footNav div 上时逐一触发动画 */
.footNav > div:nth-child(1):hover li:nth-child(1) a {
  animation: wave 1s ease-out forwards;
  animation-delay: 0s;
}

.footNav > div:nth-child(1):hover li:nth-child(2) a {
  animation: wave 1s ease-out forwards;
  animation-delay: 0.2s;
}

.footNav > div:nth-child(1):hover li:nth-child(3) a {
  animation: wave 1s ease-out forwards;
  animation-delay: 0.4s;
}

.footNav > div:nth-child(1):hover li:nth-child(4) a {
  animation: wave 1s ease-out forwards;
  animation-delay: 0.6s;
}

.footNav > div:nth-child(1):hover li:nth-child(5) a {
  animation: wave 1s ease-out forwards;
  animation-delay: 0.8s;
}

.footNav > div:nth-child(1):hover li:nth-child(6) a {
  animation: wave 1s ease-out forwards;
  animation-delay: 1s;
}

/* 定义波浪动画 */
@keyframes wave {
  0% {
    opacity: 0;
    transform: translateY(10px);
  }

  50% {
    opacity: 1;
    transform: translateY(-10px); /* 上移效果 */
  }

  100% {
    opacity: 1;
    transform: translateY(0);
  }
}
    .qrCodeList {
        display: flex;
        align-items: center;
        width: 58%;
        margin: auto;
        justify-content: space-between;
    }

    .qrCodeList>div {
        width: 10vw;
        height: 10vw;
    }

    .footInfo {
        flex: 1;
    }

    .footInfo>div:nth-child(2)>div {
        display: flex;
        align-items: center;
        color: #999999;
        font-size: 1vw;
        font-weight: 600;
        margin-bottom: 1.5vw;
        opacity: 0.8;
    }

    .footInfo>div:nth-child(2)>div>div:nth-child(1) {
        margin-right: 0.5vw;
    }

    .footInfo>div:nth-child(2)>div>div:nth-child(2) {
        width: 23vw;
        text-align: left;
    }

    .logo {
        width: 4.5vw;
        margin-bottom: 1vw;
    }
    .ICPStyle{
        display: flex;
        background-color: #00A2E9;
        color: black;
        font-size: 0.9vw;
        justify-content: space-between;
        padding: 1vw 4vw 1vw 4vw;
        margin-top: 4vw;
    }
    .LgaStyle{
        display: flex;
        align-items: center;
    }
    .LgaStyle>img{
        width: 1.5vw;
        height: 1.5vw;
        margin-right: 0.5vw;
    }
</style>